module.exports = __webpack_public_path__ + "img/plane-transit.061caf93.svg";